import { useCallback, useEffect } from "react";
import api from "../services/api";
import { getCurrentPosition } from "../utils/geolocation";

/**
 * Periodically syncs GPS to the backend for marketplace matching (customer + caregiver).
 */
export function useRoleLocationSync(role, { enabled = true, intervalMs = 60 * 1000 } = {}) {
  const sync = useCallback(async () => {
    if (!enabled || !role) return;
    const coords = await getCurrentPosition({ timeout: 10000, maximumAge: 0 });
    if (!coords) return;
    try {
      if (role === "caregiver" && api.updateCaregiverLocation) {
        await api.updateCaregiverLocation(coords);
      } else if (role === "customer" && api.updateCustomerLocation) {
        await api.updateCustomerLocation(coords);
      }
    } catch {
      // Best-effort; last saved coordinates remain in use.
    }
  }, [enabled, role]);

  useEffect(() => {
    if (!enabled || !role) return undefined;
    sync();
    const interval = window.setInterval(sync, intervalMs);
    function onVisible() {
      if (document.visibilityState === "visible") sync();
    }
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [enabled, intervalMs, role, sync]);
}
